module.exports = __webpack_public_path__ + "resources/img/solution_game_kr_m.1cb97654f9ec4b057286078397e26d45.png";